import { latRegex, lonRegex } from '../types/types'

export const validateLatitude = (value: string) => {
  if (!value) {
    return 'Incident latitude is required'
  }
  if (!latRegex.test(value)) {
    return 'Enter a valid incident latitude'
  }
  return true
}

export const validateLongitude = (value: string) => {
  if (!value) {
    return 'Incident longitude is required'
  }
  if (!lonRegex.test(value)) {
    return 'Enter a valid incident longitude'
  }
  return true
}
